import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        in_progress: "border-transparent bg-[hsl(var(--status-in-progress))] text-[hsl(var(--status-in-progress-foreground))]",
        draft: "border-transparent bg-[hsl(var(--status-draft))] text-[hsl(var(--status-draft-foreground))]",
        sent: "border-transparent bg-[hsl(var(--status-sent))] text-[hsl(var(--status-sent-foreground))]",
        approved: "border-transparent bg-[hsl(var(--status-approved))] text-[hsl(var(--status-approved-foreground))]",
        to_do: "border-transparent bg-[hsl(var(--status-todo))] text-[hsl(var(--status-todo-foreground))]",
        prospect_new: "border-transparent bg-[hsl(var(--prospect-new))] text-[hsl(var(--prospect-new-foreground))]",
        prospect_contacted: "border-transparent bg-[hsl(var(--prospect-contacted))] text-[hsl(var(--prospect-contacted-foreground))]",
        prospect_qualified: "border-transparent bg-[hsl(var(--prospect-qualified))] text-[hsl(var(--prospect-qualified-foreground))]",
        prospect_presentation: "border-transparent bg-[hsl(var(--prospect-presentation))] text-[hsl(var(--prospect-presentation-foreground))]",
        prospect_negotiation: "border-transparent bg-[hsl(var(--prospect-negotiation))] text-[hsl(var(--prospect-negotiation-foreground))]",
        prospect_won: "border-transparent bg-[hsl(var(--prospect-won))] text-[hsl(var(--prospect-won-foreground))]",
        prospect_lost: "border-transparent bg-[hsl(var(--prospect-lost))] text-[hsl(var(--prospect-lost-foreground))]",
        prospect_no_response: "border-transparent bg-[hsl(var(--prospect-no-response))] text-[hsl(var(--prospect-no-response-foreground))]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
